const LightIcon = ({ strokeColor = '#808080' }) => (
  <svg
    viewBox="0 0 795.1 795.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>{`
        .cls-1 { fill: #fcfcfc; }
        .cls-2 { fill: #4d4d4d; }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-5 { fill: #fbfbfb; }
      `}</style>
    </defs>

    <g>
      <circle className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g>
      <path
        className="cls-1"
        d="M294.43,439.64c-6.79-1.52-13.5-1.83-18.58-4.87-6.6-3.96-6.98-12.9-1.71-20.74,12.33-18.33,25.01-36.42,37.57-54.59,1.78-2.58,3.63-5.12,4.88-6.88-8.26-7.41-16.37-14.18-23.87-21.57-5.47-5.39-7.98-12.14-7.66-20.25.53-13.26.35-26.56.11-39.84-.13-7.06,3.04-9.9,9.83-9.89,68.14.07,136.27.12,204.41.05,7.26,0,10.68,3.11,10.72,10.3.07,14.43,1.08,28.92.09,43.28-.95,13.77-11.25,22.11-21.51,29.79-3.4,2.54-7.32,4.4-11.39,6.8,13.24,17.76,26.32,35.23,39.33,52.77,2.22,2.99,3.9,6.39,6.17,9.33,8.89,11.55-2.02,25.89-13.67,25.85-28.57-.1-57.15.34-85.73.41-42.73.09-85.46.04-128.99.06M454.46,379.71c-4.45-6.01-8.43-12.47-13.54-17.85-2.83-2.97-7.52-5.74-11.45-5.84-21.93-.57-43.88-.38-65.82-.21-2.67.02-6.5.64-7.81,2.43-10.25,14-20.01,28.35-30.6,43.58h145.39c-5.75-7.83-10.61-14.45-16.18-22.11M403.98,317.24c16.44,0,32.88,0,49.32.03,11.22.02,11.44-.18,11.25-11.69-.03-1.66-.25-3.33-.4-5.17h-132.28c0,2.5.24,4.26-.04,5.94-1.45,8.63,1.61,11.47,10.71,11.12,19.87-.77,39.8-.23,61.43-.23Z"
      />
      <path
        className="cls-5"
        d="M204.85,205.23c126.62,0,252.47,0,378.32.06,3.99,0,8.11.2,11.93,1.2,8.44,2.22,14.04,9.92,13.54,17.73-.57,8.83-7.49,16.1-16.47,17.18-2,.24-4.03.24-6.05.24-125.28.01-250.55.02-375.83-.04-3.97,0-8.15-.15-11.86-1.37-7.88-2.6-12.49-10.02-11.98-17.91.57-8.86,5.89-14.01,18.39-17.08Z"
      />
      <path
        className="cls-1"
        d="M441.43,492.12c4.63,26.71,9.14,52.69,13.68,78.67,1.53,8.74,3.05,17.48,4.75,26.18,1.84,9.41-2.87,17.64-11.7,20.09-8.76,2.43-17.03-2.34-19.03-12.35-4.43-22.19-8.14-44.52-12.15-66.8-2.74-15.21-5.56-30.4-8.17-45.63-1.24-7.25-2.07-15.5,5.04-19.52,4.88-2.76,12.3-3.8,17.67-2.31,10.06,2.79,8.24,13.07,9.9,21.67h0Z"
      />
      <path
        className="cls-1"
        d="M337.34,574.16c3.49-22.59,6.87-44.42,10.32-66.23,1.11-7.06,2-14.19,3.64-21.13,2.27-9.61,8.8-13.23,19.82-11.71,7.75,1.07,12.03,6.01,11.03,15.44-1.72,16.23-4.37,32.36-6.85,48.49-3.35,21.8-6.72,43.6-10.44,65.34-2,11.66-10.29,17.46-19.85,14.94-8-2.11-11.42-7.89-11.07-15.34.46-9.71,2.15-19.36,3.39-29.8h0Z"
      />
      <path
        className="cls-1"
        d="M512.57,577.05c-12.79-25.8-25.33-51-37.84-76.22-2.01-4.06-4.13-8.08-5.85-12.26-3.39-8.2-.87-15.6,6.5-19.88,7.06-4.09,15.4-2.41,20.45,4.82,3.08,4.42,5.25,9.49,7.73,14.31,12.78,24.84,25.44,49.74,38.31,74.52,6.06,11.66,4.02,21.1-6.06,26.09-9.49,4.69-16.86,1.23-23.25-11.39h0Z"
      />
      <path
        className="cls-1"
        d="M305.14,528.15c-8.61,17.19-16.8,33.87-25.11,50.49-5.86,11.71-13.78,15.06-23.19,10.02-9.39-5.03-10.87-13.53-5-25.1,14.19-27.97,28.18-56.03,42.16-84.1,3.44-6.91,8.8-11.66,16.33-9.29,5.06,1.59,10.06,5.84,13.15,10.26,1.83,2.62,1.01,8.37-.54,11.85-5.35,11.98-11.54,23.58-17.78,35.87h0Z"
      />
    </g>
  </svg>
);

export default LightIcon;